import { mapState } from "vuex";
export default {
  name: "LoadingIndicator",
  computed: mapState("loading", {
    loaders: state => state.loaders
  })
};